export default {
	AUTOCOMPLETE: 'companies/:company_id/address/autocomplete',
}
